import { InvoicesService_invoicesServiceGetGet } from '@festina/moneyin-general-types/moneyin/hooks/InvoicesService_invoicesServiceGetGet'

export const useFetchInvoiceOverviewCollectionNoSuspense =
  InvoicesService_invoicesServiceGetGet.useQuery
